import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

const MenuQuinzaineBilling = props => {
  const { optionFinance, periode, anchorEl, currentYear, handleClose, handleFetchData } = props;
  return (
    <Menu
      id='simple-menu'
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      PaperProps={{
        style: {
          maxHeight: 350,
          width: 250
        }
      }}
    >
      {optionFinance[currentYear].map((e, i) => (
        <MenuItem selected={periode === e.toShow} key={e.toShow} onClick={() => handleFetchData(e)}>
          {e.toShow}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default MenuQuinzaineBilling;
